import styled from 'styled-components';

export const ColumnChartWidgetStyled = styled.div``;
